document.addEventListener('DOMContentLoaded', function() {
  const calculator = document.querySelector('.quantity-calculator');

  if (!calculator) {
    return;
  }

  const sqFtNeeded = calculator.querySelector('#sq-ft-needed');
  const overage = calculator.querySelector('#overage');
  const totalSqFt = calculator.querySelector('#total-sq-ft');
  const numberOfBoxes = calculator.querySelector('#number-of-boxes');
  const totalPrice = calculator.querySelector('.quantity-calculator__total-price');
  const calculatedQuantity = calculator.querySelector('#calculated-quantity');

  // Sold in multiples (custom.quantity_increment): Liquid swaps the ft input and
  // overage for a stepper in the product's own unit, so those two are absent then.
  const increment = parseInt(calculator.dataset.quantityIncrement, 10) || 1;
  const stepper = calculator.querySelector('[data-increment-stepper]');
  const stepperInput = stepper ? stepper.querySelector('input') : null;
  const stepperMinus = stepper ? stepper.querySelector('[name="minus"]') : null;
  const isStepperMode = increment > 1 && !!stepperInput;

  if (!totalSqFt || !numberOfBoxes || !totalPrice || !calculatedQuantity) {
    return;
  }
  if (!isStepperMode && (!sqFtNeeded || !overage)) {
    return;
  }

  const pricePerUnitCents = Number(calculator.dataset.pricePerUnitCents) || 0;
  const moneyFormat = calculator.dataset.moneyFormat || '${{amount}}';
  const currencyCode = calculator.dataset.currencyCode || 'USD';
  const sqFtPerBox = Number(calculator.dataset.sqFtPerBox) || 20;
  const minimumSqFt = Number(calculator.dataset.minimumSqFt) || 0;

  // Limited-stock cap. Absent attribute (pre-order / untracked) means no cap.
  // Mutable: refreshed when the selected variant changes (see variantChange below).
  function readMaxQuantity(el) {
    const raw = (el || calculator).dataset.maxQuantity;
    const parsed = raw === undefined || raw === '' ? NaN : Number(raw);
    return Number.isFinite(parsed) ? parsed : Infinity;
  }
  let maxQuantity = readMaxQuantity();

  // Whether the server rendered the add-to-cart button disabled (sold out /
  // unavailable / quantity-rule). The calculator must never re-enable it; it only
  // layers the below-minimum gate on top. Refreshed on variant change.
  function readServerButtonDisabled(root) {
    const btn = (root || document).querySelector('.product-form__submit[name="add"]');
    return btn ? btn.hasAttribute('disabled') : false;
  }
  let serverButtonDisabled = readServerButtonDisabled();

  const unitSingular = calculator.dataset.unitSingular || 'box';
  const unitPlural = calculator.dataset.unitPlural || 'boxes';
  // The "(N …)" beside Total Price. On a sell-in-multiples piece product Liquid emits
  // the pieces per box, and the count is in boxes whenever the quantity is a whole
  // number of them (24 pieces at 6 per box: "(4 boxes)"). Otherwise the sold unit.
  const countPerBox = parseInt(calculator.dataset.countPerBox, 10) || 0;
  const boxSingular = calculator.dataset.boxSingular || 'box';
  const boxPlural = calculator.dataset.boxPlural || 'boxes';
  function totalCountText(quantity) {
    if (countPerBox > 0 && quantity % countPerBox === 0) {
      const boxCount = quantity / countPerBox;
      return `(${boxCount} ${boxCount === 1 ? boxSingular : boxPlural})`;
    }
    return `(${quantity} ${quantity === 1 ? unitSingular : unitPlural})`;
  }
  const coverageSuffix = calculator.dataset.coverageSuffix || 'Sq Ft';
  const resultBoxes = calculator.querySelector('[data-calc-boxes]');
  const resultCoverage = calculator.querySelector('[data-calc-coverage]');
  const totalCount = calculator.querySelector('[data-calc-count]');
  const stockTemplate = calculator.dataset.stockTemplate || 'Only [count] [unit] left in stock.';
  const stockNotice = calculator.querySelector('.quantity-calculator__stock-notice');
  const stockNoticeBody = calculator.querySelector('.quantity-calculator__stock-notice-body');
  // Fewer than one whole multiple on hand: Liquid emits a cap of 0, and "Only 0 pieces
  // left" would read as sold out, so that case has its own copy.
  const stockNoneTemplate = calculator.dataset.stockNoneTemplate || '';
  const incrementNotice = calculator.querySelector('#increment-quantity-notice');
  const incrementNoticeTemplate = calculator.dataset.incrementNoticeTemplate || '';

  // Button labels for the pre-order conversion (when the full amount exceeds on-hand stock).
  const preOrderLabel = (window.variantStrings && window.variantStrings.preOrder) || 'Pre Order';
  const addToCartLabel = (window.variantStrings && window.variantStrings.addToCart) || 'Add to Cart';
  // Global default lead time (theme setting) stamped onto a converted pre-order line.
  const defaultLeadTime = (calculator.dataset.defaultLeadTime || '').trim();

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const amount = cents / 100;
    if (window.Intl?.NumberFormat) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
      }).format(amount);
    }

    return `$${amount.toFixed(2)}`;
  }

  function formatSqFtValue(value) {
    return Number(value).toFixed(2).replace(',', '.');
  }

  // Mirror the calculated boxes/coverage into the info-card result line and the
  // "(N boxes)" counter beside Total Price.
  function updateResultDisplay(boxes, coverageSqFt) {
    const unit = boxes === 1 ? unitSingular : unitPlural;
    if (resultBoxes) resultBoxes.textContent = `${boxes} ${unit}`;
    if (resultCoverage) resultCoverage.textContent = `${formatSqFtValue(coverageSqFt)} ${coverageSuffix}`;
    if (totalCount) totalCount.textContent = totalCountText(boxes);
  }

  // Round up, never down: a few spare pieces beat an order that comes up short.
  function roundUpToIncrement(value) {
    return Math.max(increment, Math.ceil(value / increment) * increment);
  }

  // Stepper mode: the stepper value IS the quantity, so there is no ft-to-unit
  // conversion; coverage is derived from it for the info card and the stamped
  // Total Linear.Ft / Total Sq.Ft property.
  let pendingAnnouncement = '';
  let lastStepperQuantity = null;
  function calculateFromStepper() {
    const quantity = roundUpToIncrement(parseInt(stepperInput.value, 10) || increment);
    lastStepperQuantity = quantity;
    const coverage = quantity * sqFtPerBox;
    numberOfBoxes.value = quantity;
    totalSqFt.value = formatSqFtValue(coverage);
    updateResultDisplay(quantity, coverage);

    const formattedTotal = formatMoney(quantity * pricePerUnitCents);
    totalPrice.textContent = formattedTotal;

    // aria-disabled rather than disabled, so focus stays on the button at the floor.
    if (stepperMinus) stepperMinus.setAttribute('aria-disabled', quantity <= increment ? 'true' : 'false');

    const isValidQuantity = minimumSqFt === 0 || coverage >= minimumSqFt;
    updateFormState(isValidQuantity, quantity);

    const unit = quantity === 1 ? unitSingular : unitPlural;
    const announcement = `${quantity} ${unit}, total price ${formattedTotal}`;
    const announcer = calculator.querySelector('#calculation-announcer');
    if (announcer) announcer.textContent = pendingAnnouncement ? `${pendingAnnouncement} ${announcement}` : announcement;
    pendingAnnouncement = '';
  }

  // A typed value is committed on change / Enter (never per keystroke). Anything that
  // isn't a multiple rounds up to the next one, and the notice says what happened.
  function commitStepper() {
    const raw = parseInt(stepperInput.value, 10);
    const committed = roundUpToIncrement(Number.isFinite(raw) && raw > 0 ? raw : increment);
    // Enter commits, and the browser may follow with its own change event: a second
    // pass with nothing new must not overwrite the announcement the first one queued.
    if (committed === raw && committed === lastStepperQuantity) return;
    stepperInput.value = committed;
    if (Number.isFinite(raw) && raw !== committed) {
      const message = incrementNoticeTemplate.replace('[quantity]', committed);
      if (incrementNotice) incrementNotice.textContent = message;
      pendingAnnouncement = message;
    }
    calculateQuantity();
  }

  function stepBy(direction) {
    const current = roundUpToIncrement(parseInt(stepperInput.value, 10) || increment);
    stepperInput.value = Math.max(increment, current + direction * increment);
    if (incrementNotice) incrementNotice.textContent = '';
    calculateQuantity();
  }

  function calculateQuantity() {
    if (isStepperMode) {
      calculateFromStepper();
      return;
    }

    const sqFt = parseFloat(sqFtNeeded.value) || 0;
    const overageValue = parseFloat(overage.value);
    const overagePercent = Number.isNaN(overageValue) ? 0 : overageValue;

    // Check minimum square footage requirement
    const isValidQuantity = minimumSqFt === 0 ? true : sqFt >= minimumSqFt && sqFt > 0;

    if (sqFt > 0) {
      // Calculate total sq ft with overage
      const totalSqFtValue = sqFt * (1 + overagePercent);

      // Calculate number of boxes/pieces/bundles/slabs needed. Subtract a tiny
      // epsilon before ceil so floating-point dust doesn't add a box: e.g.
      // 100 * 1.1 === 110.00000000000001, and 110.00000000000001 / 5 ===
      // 22.000000000000004, which would otherwise ceil to 23 instead of 22.
      const boxesNeeded = Math.ceil(totalSqFtValue / sqFtPerBox - 1e-9);
      numberOfBoxes.value = boxesNeeded;

      // Total coverage based on rounded boxes
      const totalCoverageSqFt = boxesNeeded * sqFtPerBox;
      totalSqFt.value = formatSqFtValue(totalCoverageSqFt);
      updateResultDisplay(boxesNeeded, totalCoverageSqFt);

      // Calculate total price
      const totalCents = boxesNeeded * pricePerUnitCents;
      const formattedTotal = formatMoney(totalCents);
      totalPrice.textContent = formattedTotal;

      // Show/hide minimum warning and update form state
      updateMinimumWarning(totalCoverageSqFt, isValidQuantity);
      updateFormState(isValidQuantity, boxesNeeded);

      // Announce to screen readers
      announceCalculation(boxesNeeded, formattedTotal, isValidQuantity);
    } else {
      // Show default values for 1 unit when no sq ft is entered
      totalSqFt.value = formatSqFtValue(sqFtPerBox);
      numberOfBoxes.value = '1';
      updateResultDisplay(1, sqFtPerBox);
      const defaultTotal = formatMoney(pricePerUnitCents);
      totalPrice.textContent = defaultTotal;

      const isValidQuantity = minimumSqFt === 0;

      // Hide minimum warning when no input
      updateMinimumWarning(0, isValidQuantity);
      updateFormState(isValidQuantity, 1);

      // Announce to screen readers
      announceCalculation(1, defaultTotal, isValidQuantity);
    }
  }

  // Add event listeners
  if (isStepperMode) {
    stepperMinus.addEventListener('click', () => {
      if (stepperMinus.getAttribute('aria-disabled') !== 'true') stepBy(-1);
    });
    stepper.querySelector('[name="plus"]').addEventListener('click', () => stepBy(1));
    stepperInput.addEventListener('change', commitStepper);
    stepperInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      commitStepper();
    });
    // Typing a new value makes the last "Quantity increased" notice stale.
    stepperInput.addEventListener('input', () => {
      if (incrementNotice) incrementNotice.textContent = '';
    });
  } else {
    sqFtNeeded.addEventListener('input', calculateQuantity);
    overage.addEventListener('change', calculateQuantity);
  }

  // Overage dropdown: a native <details> disclosure standing in for a <select>.
  // Selecting an option writes the hidden #overage input and fires 'change', so
  // the calculation path above is unchanged.
  const overageDropdown = calculator.querySelector('[data-overage-dropdown]');
  if (overageDropdown) {
    const overageLabel = overageDropdown.querySelector('[data-overage-label]');
    const overageOptions = overageDropdown.querySelectorAll('.quantity-calculator__dropdown-option');

    overageOptions.forEach(option => {
      option.addEventListener('click', function() {
        overage.value = this.dataset.value;
        if (overageLabel) overageLabel.textContent = this.textContent;
        overageOptions.forEach(o => o.removeAttribute('aria-current'));
        this.setAttribute('aria-current', 'true');
        overageDropdown.removeAttribute('open');
        overage.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Close on outside click or Escape.
    document.addEventListener('click', function(e) {
      if (!overageDropdown.contains(e.target)) overageDropdown.removeAttribute('open');
    });
    overageDropdown.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        overageDropdown.removeAttribute('open');
        const summary = overageDropdown.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  }

  // Add keyboard support for tooltip buttons
  calculator.querySelectorAll('.quantity-calculator__tooltip').forEach(tooltip => {
    tooltip.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.classList.toggle('quantity-calculator__tooltip--active');
      }
      if (e.key === 'Escape') {
        this.classList.remove('quantity-calculator__tooltip--active');
      }
    });

    tooltip.addEventListener('click', function() {
      this.classList.toggle('quantity-calculator__tooltip--active');
    });

    // Close tooltip when clicking outside
    document.addEventListener('click', function(e) {
      if (!tooltip.contains(e.target)) {
        tooltip.classList.remove('quantity-calculator__tooltip--active');
      }
    });
  });

  // Flag the below-minimum state: red-border the input and highlight the inline
  // "{min} min." label. (The minimum is now always surfaced next to the label,
  // so there's no tooltip to reveal.)
  function updateMinimumWarning(sqFt, isValid) {
    if (minimumSqFt <= 0) return;
    const sqFtInput = calculator.querySelector('#sq-ft-needed');
    const minLabel = calculator.querySelector('.quantity-calculator__label-min');
    const belowMinimum = sqFt > 0 && !isValid;
    if (sqFtInput) sqFtInput.classList.toggle('quantity-calculator__input--error', belowMinimum);
    if (minLabel) minLabel.classList.toggle('quantity-calculator__label-min--error', belowMinimum);
  }

  // Update form state. Exceeding on-hand stock (only possible for a tracked,
  // in-stock variant) converts the order to a pre-order instead of capping it:
  // the full quantity is submitted, the buy button reads "Pre Order", a hidden
  // Item Type=Pre-Order property is stamped, and the inventory line shows the
  // lead time. Below the minimum order still disables checkout.
  function updateFormState(isValid, quantity) {
    const safeQuantity = quantity || 1;
    const addToCartButton = document.querySelector('.product-form__submit[name="add"]');
    const paymentButton = document.querySelector('.shopify-payment-button__button');

    const belowMinimum = minimumSqFt > 0 && !isValid;
    const exceedsStock = safeQuantity > maxQuantity;
    const isPreorderConversion = exceedsStock && !belowMinimum;
    // Only manage the button label for variants that can be capped (finite
    // maxQuantity); leave server-rendered labels (sold out / pre-order) alone.
    const canConvert = Number.isFinite(maxQuantity);

    // Submitted quantity: the smallest sellable amount below the minimum order (1, or
    // one multiple), otherwise the full calculated amount — a pre-order conversion is
    // NOT clamped to stock.
    const effectiveQuantity = belowMinimum ? increment : safeQuantity;

    // Sync every cart quantity input and notify Dawn's listeners (only on change,
    // so dispatched change events don't loop back through this handler).
    document.querySelectorAll('input[name="quantity"], .quantity__input').forEach(input => {
      if (Number(input.value) !== effectiveQuantity) {
        input.value = effectiveQuantity;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Keep the tile line-item property fields in sync with the calculated quantity
    // and total. These ride along on add-to-cart so they persist onto the order line.
    const countProp = document.querySelector('[data-line-property="count"]');
    const totalFtProp = document.querySelector('[data-line-property="total-ft"]');
    if (countProp) countProp.value = effectiveQuantity;
    if (totalFtProp && totalSqFt.value) totalFtProp.value = totalSqFt.value;

    // Below the minimum order gates checkout; exceeding stock no longer does
    // (it becomes a pre-order). The calculator only ADDS the below-minimum gate —
    // it must not re-enable a button the server disabled (sold out / unavailable).
    const shouldDisable = belowMinimum || serverButtonDisabled;
    toggleButton(addToCartButton, shouldDisable);
    toggleButton(paymentButton, shouldDisable);

    if (canConvert && addToCartButton) {
      const label = addToCartButton.querySelector('span');
      if (label) label.textContent = isPreorderConversion ? preOrderLabel : addToCartLabel;
    }

    togglePreorderProperties(addToCartButton, isPreorderConversion, canConvert);
    updateInventoryState(isPreorderConversion);
    updateStockNotice(isPreorderConversion);
  }

  // Add/remove the hidden pre-order line-item properties (Item Type=Pre-Order and
  // Lead Time=global default) on the product form so a converted line is marked as
  // a pre-order, carries its lead time, and is recognized by the cart (which
  // exempts pre-order lines from its in-stock cap).
  function togglePreorderProperties(addToCartButton, on, canConvert) {
    const form = addToCartButton ? addToCartButton.closest('form') : null;
    if (!form) return;
    const removePreorderInputs = (jsOnly) =>
      form.querySelectorAll('input[name="properties[Item Type]"]').forEach((el) => {
        if (el.value === 'Pre-Order' && (!jsOnly || el.hasAttribute('data-preorder-marker'))) el.remove();
      });

    if (on) {
      // Drop a stale server-rendered Pre-Order input (carried over from an
      // out-of-stock variant) but keep/reuse our own JS marker, then add it only
      // if absent — so we don't churn the DOM on every keystroke.
      form.querySelectorAll('input[name="properties[Item Type]"]').forEach((el) => {
        if (el.value === 'Pre-Order' && !el.hasAttribute('data-preorder-marker')) el.remove();
      });
      if (!form.querySelector('input[data-preorder-marker]')) {
        const marker = document.createElement('input');
        marker.type = 'hidden';
        marker.name = 'properties[Item Type]';
        marker.value = 'Pre-Order';
        marker.setAttribute('data-preorder-marker', '');
        form.appendChild(marker);
      }
    } else if (canConvert) {
      // In-stock, not converting: clear any Pre-Order marker — including a stale
      // server-rendered one from a previously selected OOS variant — so the cart
      // re-applies its in-stock cap to this line.
      removePreorderInputs(false);
    } else {
      // Uncapped variant (genuine pre-order / untracked): the server owns the
      // marker; only remove one this script created.
      removePreorderInputs(true);
    }

    // Lead Time = global default. Only our JS-managed input is touched; it is
    // appended last so it overrides any server-rendered product Lead Time while
    // converting, and removing it restores the server value when not converting.
    const jsLeadTime = form.querySelector('input[data-preorder-lead-time]');
    if (on && defaultLeadTime) {
      if (!jsLeadTime) {
        const leadTime = document.createElement('input');
        leadTime.type = 'hidden';
        leadTime.name = 'properties[Lead Time]';
        leadTime.value = defaultLeadTime;
        leadTime.setAttribute('data-preorder-lead-time', '');
        form.appendChild(leadTime);
      }
    } else if (jsLeadTime) {
      jsLeadTime.remove();
    }
  }

  // Swap the inventory status line between its default (in-stock) state and the
  // pre-order state (truck icon + lead time). Re-queried each call so it survives
  // the wholesale #Inventory re-render product-info.js performs on variant change.
  function updateInventoryState(on) {
    const inventory = document.querySelector('.product__inventory');
    if (!inventory) return;
    const def = inventory.querySelector('.product__inventory-default');
    const pre = inventory.querySelector('.product__inventory-preorder');
    if (!def || !pre) return;
    def.hidden = on;
    pre.hidden = !on;
  }

  function toggleButton(button, disabled) {
    if (!button) return;
    if (disabled) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    }
  }

  // Show/hide the limited-stock notice ("Only X boxes left ...").
  function updateStockNotice(exceedsStock) {
    if (!stockNotice || !stockNoticeBody) return;
    if (exceedsStock && Number.isFinite(maxQuantity)) {
      const unit = maxQuantity === 1 ? unitSingular : unitPlural;
      stockNoticeBody.textContent =
        maxQuantity === 0 && stockNoneTemplate
          ? stockNoneTemplate
          : stockTemplate.replace('[count]', maxQuantity).replace('[unit]', unit);
      stockNotice.hidden = false;
    } else {
      stockNotice.hidden = true;
    }
  }

  // Announce calculation results to screen readers
  function announceCalculation(boxes, total, isValid) {
    let announcement = `Calculation updated: ${boxes} boxes needed, total price ${total}`;

    if (minimumSqFt > 0 && !isValid) {
      announcement += `. Warning: Minimum order is ${minimumSqFt} square feet.`;
    }

    const announcer = calculator.querySelector('#calculation-announcer');
    if (announcer) {
      announcer.textContent = announcement;
    }
  }

  function initializeCalculation() {
    calculateQuantity();
  }

  // Refresh the stock cap when the selected variant changes. product-info.js
  // publishes the freshly fetched section HTML, which carries the new variant's
  // data-max-quantity on the calculator element.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const freshHtml = event && event.data && event.data.html ? event.data.html : null;
      maxQuantity = readMaxQuantity((freshHtml && freshHtml.querySelector('.quantity-calculator')) || calculator);
      if (freshHtml) serverButtonDisabled = readServerButtonDisabled(freshHtml);
      initializeCalculation();
    });
  }

  // Initialize with default values showing 1 box coverage and price
  initializeCalculation();

  window.addEventListener('pageshow', initializeCalculation);
});
